import { render } from "./AlertsNotification.vue?vue&type=template&id=16674f0f&scoped=true&ts=true"
import script from "./AlertsNotification.vue?vue&type=script&lang=ts"
export * from "./AlertsNotification.vue?vue&type=script&lang=ts"

import "./AlertsNotification.vue?vue&type=style&index=0&id=16674f0f&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16674f0f"]])

export default __exports__